import { render } from "./VisionContent.vue?vue&type=template&id=e77a501a&scoped=true&ts=true"
import script from "./VisionContent.vue?vue&type=script&lang=ts"
export * from "./VisionContent.vue?vue&type=script&lang=ts"

import "./VisionContent.vue?vue&type=style&index=0&id=e77a501a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77a501a"]])

export default __exports__